import { useParams, useSearchParams } from 'react-router-dom';
import { useUpdateUnitMissionCapability } from "../hooks/UnitMissionCapabilityHooks";
import { UnitMissionCapabilityForUnitAndMissionDTO } from "../types/unitMissionCapabilityForUnitAndMissionDTO";
import ValidationSummary from "../ValidationSummary";
import { toast } from 'react-toastify';
import UnitMissionCapabilityForm from "./UnitMissionCapabilityForm";
import { ClipLoader } from 'react-spinners';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

const UnitMissionCapabilityAdd = () => {
  const { t } = useTranslation();
  const createValidToDate = () => {
    const date = new Date();
    date.setFullYear(2099);
    date.setSeconds(0, 0);
    return date;
  };
  const { organisationId } = useParams<{ organisationId: string }>();
  if (!organisationId) throw new Error("Missing organisationId from params");
  const [searchParams] = useSearchParams();
  const unitId = searchParams.get('unitId');
  const [unitMissionCapabilityForUnitAndMission, _setUnitMissionCapabilityForUnitAndMission] = useState<UnitMissionCapabilityForUnitAndMissionDTO>({
    unit: {
      id: unitId ?? "00000000-0000-0000-0000-000000000000",
      name: "",
      organisationId: organisationId,
      validFrom: new Date(new Date().setSeconds(0, 0)),
      validTo: createValidToDate(),
      lastModified: new Date(),
      strength: {
        platoonLeaderCount: 0,
        sectionLeaderCount: 0,
        crewCount: 0
          },
      priority:0,
      station: {
        id: "",
        organisationId: organisationId,
        address: "",
        name: "",
        municipality: "",
        validFrom: new Date(new Date().setSeconds(0, 0)),
        validTo: createValidToDate(),
        lastModified: new Date(),
      },
    },
    missionCode: {
      id: "00000000-0000-0000-0000-000000000000",
      codedValue: "", value: "",
      codeSystemId: '',
      validFrom: new Date(new Date().setSeconds(0, 0)),
      validTo: createValidToDate()
    },
      desiredCapabilities: [],
      requiredGroups: []
  });


    // Use update instead of add to overwrite existing values. It makes multiselection easier for user.
    const updateUnitMissionCapabilityMutation = useUpdateUnitMissionCapability(organisationId);

  return (
    <>
          {updateUnitMissionCapabilityMutation.isError && (
              <ValidationSummary error={updateUnitMissionCapabilityMutation.error} />
      )}
          {updateUnitMissionCapabilityMutation.isPending ? (
        <div className="spinner-container" style={{ textAlign: 'center', marginTop: '20px' }}>
          <ClipLoader size={50} color={"#123abc"} loading={true} />
          <p>{t('unitMissionCapability.addWait')}</p>
        </div>
      ) : (
        <UnitMissionCapabilityForm
          headerText={t('unitMissionCapability.add')}
          isEdit={false}
          unitMissionCapabilityForUnitAndMission={unitMissionCapabilityForUnitAndMission}
          submitted={(capabilities) => {
              updateUnitMissionCapabilityMutation.mutate(capabilities, {
              onSuccess: () => {
                toast.success(t('unitMissionCapability.addSuccess'));
                history.back();
              },
              onError: () => {
                toast.error(t('unitMissionCapability.addError'));
              }
            });
          }}
          deleted={() => { }}
        />
      )}
    </>
  );
};

export default UnitMissionCapabilityAdd;